import Button from 'carbon-react/lib/components/button';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { FormattedMessage } from '@futrli/localisation';
import { ROUTES, SfaFatalError } from '@futrli/shared-services';
import { UIDefaultErrorMessage } from '@futrli/ui-components';
import { ERROR_STATUS } from '../core/constants';
import { cleanErrorAndGoToPath } from '../utils/error-boundary-utils';
import image from './images/internal-error.svg';

interface Props {
  errorStatus?: number;
}

/**
 * Get the error status and the message to render.
 *
 * @todo Only 404 error has a friendly message at the moment but more
 * messages have to be added.
 *
 * @param {number} errorStatus
 * @returns {JSX.Element}
 */
const getErrorMessageToRender = (errorStatus: number | undefined): JSX.Element => {
  if (!errorStatus || errorStatus !== ERROR_STATUS._404) {
    return <UIDefaultErrorMessage />;
  }

  return <FormattedMessage id="errors.page_not_found" defaultMessage="Sorry, the page you requested was not found." />;
};

/**
 * Generic error component.
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
const ErrorFC: React.FC<Props> = ({ errorStatus }: Props): JSX.Element => {
  const navigate = useNavigate();

  return (
    <SfaFatalError
      image={image}
      title={errorStatus}
      subtitle={getErrorMessageToRender(errorStatus)}
      text={
        <>
          <div style={{ marginBottom: 16 }}>
            <FormattedMessage id="errors.back_home" defaultMessage="Head back home." />
          </div>
          <Button buttonType="primary" size="large" onClick={cleanErrorAndGoToPath(navigate, ROUTES.ROOT_ROUTE)}>
            <FormattedMessage id="common.home" defaultMessage="Home" />
          </Button>
        </>
      }
    />
  );
};
export const Error = React.memo(ErrorFC);
